import { render, staticRenderFns } from "./CourierContent.vue?vue&type=template&id=c07c0d60&scoped=true&"
import script from "./CourierContent.vue?vue&type=script&lang=js&"
export * from "./CourierContent.vue?vue&type=script&lang=js&"
import style0 from "./CourierContent.vue?vue&type=style&index=0&id=c07c0d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07c0d60",
  null
  
)

export default component.exports